import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { LayerService } from "../../../home/services/layers/layer.service";
import { CategoryService } from "../../../home/services/category_layers/category.service";
import { FormService } from "../../../home/services/forms/form.service";
import { UsersService } from "../../services/users/users.service";

@Component({
  selector: "app-modal-form-user",
  templateUrl: "./modal-form-user.component.html",
  styleUrls: ["./modal-form-user.component.css"],
})
export class ModalFormUserComponent implements OnInit {
  formsUser: any[] = [];
  formsAdd: any[] = [];
  userId: any;

  constructor(
    public layerService: LayerService,
    public categoryService: CategoryService,
    public formService: FormService,
    public userService: UsersService,
    private dialogRef: MatDialogRef<ModalFormUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.getFormsUser(data.data);
    this.getForms();
    this.userId = data.idUser;
  }

  getFormsUser(data) {
    this.formsUser = [];
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const element = data[key];
        this.formsUser.push(element);
      }
    }
  }

  ngOnInit(): void {}

  getForms() {
    this.formsAdd = [];
    this.formService.getForms().subscribe((data: {}) => {
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const element2 = data[key];
          if (
            !this.formsUser.find(
              (element) => element.formulario_id == element2.formulario_Id
            )
          ) {
            this.formsAdd.push(element2);
          }
        }
      }
    });
  }

  selectForm(formId) {
    const form_user = {
      usuario_realgisId: this.userId,
      formulario_id: formId,
      formulario_usuario_estado: 1,
    };
    this.userService.assignFormUser(form_user).subscribe((data1: {}) => {
      this.formService.getFormsUser(this.userId).subscribe((data2: {}) => {
        this.getFormsUser(data2);
        this.getForms();
      });
    });
  }
}
